// extracted by mini-css-extract-plugin
export var container = "_dw-0";
export var popoverContent = "_dw-1";
export var tosLink = "_dw-2";